var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,_vm._g(_vm._b({tag:"component",class:[
    _vm.widget ? 'binds-ds-button' : 'binds-button',
    _vm.size,
    _vm.state,
    _vm.variation,
    _vm.outline && 'outline',
    _vm.disabled && 'disabled',
    _vm.inline && 'inline',
    _vm.inside && 'inside',
    _vm.floating && 'floating',
    _vm.dark && 'dark',
  ],attrs:{"href":_vm.href,"type":_vm.submit,"disabled":!_vm.active}},'component',_vm.$attrs,false),{
    ..._vm.$listeners,
    input: event => _vm.$emit('input', event.target.value)
  }),[(!!_vm.icon)?_c('div',{staticClass:"button-icon text-center"},[_c('icon',{attrs:{"name":_vm.icon,"size":_vm.iconSize,"color":_vm.iconColor}})],1):_vm._e(),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }